import { connect } from 'react-redux'
// Navigation handled in component
import type { PasswordStrength } from 'types/business'
import type { State } from 'types/redux'
import {
  loadMfaMethods,
  loginUser,
  updateUserSettings,
} from '@disco/state-management/actions/UserActions'
import PostInvites from './PostInvites'
type StateProps = {
  user: State['user']
  passwordStrength: PasswordStrength
}

function mapStateToProps(state: State): StateProps {
  const { business } = state.user
  return {
    user: state.user,
    passwordStrength: business
      ? business.public_metadata.password_strength
      : 'standard',
  }
}

type Actions = {
  loginUser: typeof loginUser
  updateUserSettings: typeof updateUserSettings
  loadMfaMethods: typeof loadMfaMethods
}
const actions: Actions = {
  loginUser,
  updateUserSettings,
  loadMfaMethods,
}
export default connect(mapStateToProps, actions)(PostInvites) as any
